'use client'

import { useMemo } from 'react'

import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import toObject from 'dayjs/plugin/toObject'

export default function useDateTime(): typeof dayjs {
  return useMemo(() => {
    dayjs.extend(relativeTime)
    dayjs.extend(toObject)
    dayjs.extend(localizedFormat)
    return dayjs
  }, [])
}
